const Newsletter = () => {
  return (
    <section className="newsletter-wrap">
      <div className="newsletter-card">
        <p>Join the glow club</p>
        <h2>Get skincare rituals, launches, and premium offers.</h2>
        <form>
          <input type="email" placeholder="Enter your email" />
          <button type="submit">Subscribe</button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
